module.exports = __webpack_public_path__ + "img/Buffalo-Wild-Wings_logo.c224f909.svg";